export const EACT_SCORING: { min: Number; max: Number; label: string }[] = [
  {
    min: 200,
    max: 200,
    label: "1-12"
  },
  {
    min: 201,
    max: 299,
    label: "13-15"
  },
  {
    min: 300,
    max: 399,
    label: "16-19"
  },
  {
    min: 400,
    max: 499,
    label: "20-23"
  },
  {
    min: 500,
    max: 599,
    label: "24-27"
  },
  {
    min: 600,
    max: 699,
    label: "28-32"
  },
  {
    min: 700,
    max: 799,
    label: "33-36"
  },
  {
    min: 800,
    max: 800,
    label: "33-36"
  }
]
